<template>
  <div v-if="!matchingAmounts" class="warning-amounts">
    <span v-if="this.matchedItems.length > 1">{{ warningTextMultiple }}</span>
    <span v-else>
      {{ warningText }}
      <GekkoButton 
        @click="$emit('set-to-edit', false)" 
        icon="fa-solid fa-pen-to-square"
        :text="$gettext('Edit')" 
        variant="link"
        class="text-brand py-0"
      />
    </span>
  </div>
</template>

<script>

import GekkoButton from "@/components/GekkoButton"

export default {
  name: "BankMatchedAmountsWarning",
  components: {
    GekkoButton,
  },
  props: {
    transactionAmount: {
      type: Number,
      default: null
    },
    connectorType: {
      type: String,
      default: null
    },
    matchedItems: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
    }
  },
  computed: {
    matchedAmount () {
      let total_amount = 0
      if (this.connectorType === 'cost') {
        this.matchedItems.forEach(item => {
          total_amount += parseFloat(item.amount)
        })
      }
      return total_amount
    },
    matchingAmounts () {
      return this.transactionAmount === this.matchedAmount
    },
    warningTextMultiple () {
      return this.$gettext('Transaction and combined cost amounts do not match. Click on any cost to edit it.')
    },
    warningText () {
      return this.$gettext('Transaction and cost amounts do not match, do you want to edit this cost?')
    }
  },
  created () {
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
  .warning-amounts {
    margin-top: 0.5rem;
    background: $colorWarningBg;
    color: $colorWarningText;
    border: 1px solid $colorWarningBorder;
    box-shadow: $dropdownShadow;
    padding: 0.5rem;
    border-radius: $radiusMd;
    font-size: 1rem;
  }
</style>